<template>
  <div class="card-container" :ref="cardContainerRef">
    <img :src="notification.gacha.image_path" alt="" @load="imageLoaded" @error="imageLoaded"/>
    <p>{{ notification.gacha.name }}のガチャ券を獲得！</p>
  </div>
</template>

<script>
export default {
  name: 'GachaNotifyCard',
  props: {
    notification: { type: Object, required: true },
    index: { type: Number, required: true }
  },
  computed: {
    cardContainerRef() {
      return `cardContainer${this.index}`
    }
  },
  methods: {
    imageLoaded() {
      if (this.$refs[this.cardContainerRef]) {
        const rect = this.$refs[this.cardContainerRef].getBoundingClientRect()
        this.$emit('card-loaded', { top: rect.top, bottom: rect.bottom })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card-container {
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  overflow: hidden;
  position: relative;
  padding: 28px;

  img {
    width: 100%;
  }

  p {
    margin-top: 20px;
  }
}
</style>
